import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Builder from './pages/builder/builder';
import { Provider } from 'react-redux';
import store from './state-manager/store';
import Home from './pages/Home/Home';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './lib/queryClient';
import { Toaster } from 'sonner';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <div className="App">
          <QueryClientProvider client={queryClient}>
            <Routes>
              <Route path="/builder" element={<Builder />} />
              <Route path="/template/builder/:templateId" element={<Builder />} />
              <Route path="/creative/builder/:creativeId" element={<Builder />} />
              <Route path="/" element={<Home />} />
            </Routes>
            <Toaster />
          </QueryClientProvider>
        </div>
      </Router>
    </Provider>
  );
}

export default App;
